<div class="centered-section container">
  <div class="position-relative main w-100">
    <a class="navbar-brand logo" href="#">
      <img src="../../assets/logo.png" alt="" width="40" height="40">
    </a>
    <div class="menu container w-100" id="menu">
      <div class="menu-captions">
        <a class="logo" href="#">
          <img src="../../assets/logo.png" alt="" width="30" height="30">
        </a>
        <a class="menu-links l1 mx-3" (click)="navigateTo('features')">Features</a>
        <a class="menu-links l2 mx-3" (click)="navigateTo('about')">About Wroolo</a>
        <a class="menu-links l3 mx-3" (click)="navigateTo('blog')">Blog</a>
      </div>
      <a href="https://discord.gg/ZSCxx6qTeU" class="discord-button" data-bs-toggle="tooltip" data-bs-placement="top" title="Wroolo Discord channel" data-bs-delay="{show: 10}">
        <div class="caption-discord">
          <i class="bi bi-discord"></i> 
          Join Discord
        </div>   
      </a>
      @if (pageName != 'login') {
        <div class="getstarted-button" (click)="navigateTo('login')" >
          <div class="getstarted-caption">
            Get started now
        </div>
      </div>
    }
    </div>
    <div class="hamburger" id="hamburger">
      <i class="bi bi-list"></i> 
    </div>
  </div>
</div>
